export default __webpack_public_path__ + "static/media/LA.65bcbabf.ico";